import {Component, OnInit} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {animate, style, transition, trigger} from "@angular/animations";
import {LocalStoreService, StoreSelectorsService} from "../../../services";
import {ToastrService} from "ngx-toastr";
import {ICart, ICartCreate, ICartProduct, IUser} from "../../../interfaces";
import {UserService} from "../../../services/user.service";
import {filter} from "rxjs/operators";
import {actionCartContentUpdate, actionLoadCartContentRequest} from "../../../store/actions/user.actions";
import {MatTableDataSource} from "@angular/material/table";
import {calcTotals} from "../../../common/functions_cart";
import {Compbaser} from "../../../components/compbaser";
import {StringJSV2Pipe} from "../../../pipes/stringjs-pipe";
import {isCartEmpty, isProductInUrl, states} from "../../../common";
import {Lib} from "../../../../libs/Lib";
import * as _ from 'lodash';

@Component({
    selector: 'shopping-cart',
    styleUrls: [`./shopping.component.scss`],
    templateUrl: './shopping.component.html',
    animations: [
        trigger(
            'inOutAnimation',
            [
                transition(
                    ':enter',
                    [
                        style({opacity: 0}),
                        animate('1.5s ease-out',
                            style({opacity: 1}))
                    ]
                ),
                transition(
                    ':leave',
                    [
                        style({opacity: 1}),
                        animate('1.5s ease-in',
                            style({opacity: 0}))
                    ]
                )
            ]
        )
    ]
})

export class ShoppingComponent extends Compbaser implements OnInit {
    cartProducts: Array<ICartProduct>;
    navigationEnd: NavigationEnd;
    cartCreate: ICartCreate;
    addedProduct: string = null;
    user: IUser;
    dataSource: MatTableDataSource<ICartProduct>;
    stringJSPipeArgs = {toCurrency: ['us']};
    devMode = Lib.DevMode();
    subTotal = 0;
    taxTotal = 0;
    cart: ICart;
    disabledCheckout = false;
    shippingTotal = 0;
    orderTotal = 0;
    selectedShipTo;
    selectedShipBy;
    usSates = states;
    displayedColumns: string[] = ['item', 'description', 'qty', 'price', 'total', 'remove'];
    chargeMode = false;
    productImages;
    imgStyle = {
        img: {
            'width': '60px',
            'height': '39px',
            'background-size': '60px 39px',
            'display': 'block',
        }
    };
    theme = '1';

    constructor(private translocoService: TranslocoService,
                private localStoreService: LocalStoreService,
                private userService: UserService,
                private stringJS: StringJSV2Pipe,
                private router: Router,
                private route: ActivatedRoute,
                private storeSelector: StoreSelectorsService,
                private toastr: ToastrService) {
        super();

        if (this.router.url.indexOf('charge') > -1) {
            this.chargeMode = true;
            this.displayedColumns.push('notes');
        }
        this.initCartCreate();
        this.cod(
            this.storeSelector.getAppSettings().subscribe((appStatic) => this.productImages = appStatic.productImages)
        );
        this.cod(
            this.storeSelector.getUser().subscribe((user) => this.user = user)
        );
        this.cod(
            this.storeSelector.getCartProducts().subscribe((v) => this.cartProducts = v)
        );
        this.cod(
            this.storeSelector.getCart().subscribe((v) => {
                this.cart = v;
                this.disabledCheckout = this.isCheckoutAllowed();
                if (v.cartLocation) {
                    this.selectedShipBy = v.cartLocation.split(':')[1];
                    this.selectedShipTo = v.cartLocation.split(':')[0];
                }
            })
        );
        this.cod(
            this.storeSelector.getCartContents().subscribe((v) => {
                const products: ICartProduct[] = _.cloneDeep(v);
                // custom payment link
                if (this.chargeMode) {
                    products.forEach((item) => {
                        item.price = String(item.product_price);
                    });
                    this.dataSource = new MatTableDataSource(products);
                } else {
                    this.dataSource = new MatTableDataSource(v);
                }

                this.calcTotals();
            })
        );
        this.cod(
            this.router.events.subscribe((e) => {
                if (e instanceof NavigationEnd) {
                    this.navigationEnd = e;
                }
            })
        );
        this.cod(
            this.route.paramMap.subscribe((routeParams) => {
                const v: string = routeParams.get('id');
                if (v) {
                    const productId = v.split(':')[0];
                    this.onAddCart(productId, 0);
                }
            })
        );
    }

    initCartCreate() {
        this.cartCreate = this.localStoreService.getCartCreate();
        this.theme = this.localStoreService.getStorageValConfig('theme');
        this.cod(
            this.storeSelector.getLocalStoreUpdates('ICartCreate').pipe(filter((v) => v !== null))
                .subscribe((e) => {
                    this.cartCreate = this.localStoreService.getCartCreate();
                })
        );

    }

    isCheckoutAllowed(): boolean {
        if (isCartEmpty(this.cart)) return true;
        if (!this.cart.cartLocation) return true;
        return false;
    }

    ngOnInit() {
        this.cod(
            this.route.queryParams.subscribe((v) => {
                if (v && v.product) {
                    const productId = v.product.split(':')[0];
                    this.onAddCart(productId, 0);
                }
            })
        );
    }

    onCheckout() {
        const routeTo = isProductInUrl(this.navigationEnd) ? '../../checkout' : '../checkout';
        this.router.navigate([routeTo], {relativeTo: this.route});
    }

    onSelectedShipTo(e) {
        this.selectedShipTo = e.value;
        if (e.value === 'INT') {
            this.selectedShipBy = 'USPS';
        } else {
            this.selectedShipBy = 'UPS';
        }
        this.calcTotals();
    }

    onSelectedBy(e) {
        this.selectedShipBy = e.value;
    }

    onSelectedRow(row) {
        // this.highlightedRows = [row];
        // this.router.navigate([`/editor/scene/${row.Player.$.id}`]);
    }

    isProductInUrl() {
        return !!this.navigationEnd.url.match(/list\/(.*)/);
    }

    onAddCartNav(product: ICartProduct) {
        const routeTo = this.isProductInUrl() ? `../${product.product_id}:${_.uniqueId()}` : `${product.product_id}:${_.uniqueId()}`;
        this.router.navigate([routeTo], {relativeTo: this.route});
    }

    onChangeCartQty(i_product: ICartProduct, qty) {
        const q = Number(qty);
        if (q <= 0) return;
        this.storeSelector.dispatch(actionLoadCartContentRequest({
            cartRequest: {
                serverCall: "ADD_CART_CONTENT",
                cartCreate: this.cartCreate,
                user: this?.user?.username,
                password: this?.user?.passwordNew,
                cartProductId: Number(i_product.product_id),
                qty: q,
                price: 0
            }
        }));
    }

    onRemoveCartNav(i_product: ICartProduct) {
        this.storeSelector.dispatch(actionLoadCartContentRequest({
            cartRequest: {
                serverCall: "REMOVE_CART_CONTENT",
                cartCreate: this.cartCreate,
                user: this?.user?.username,
                password: this?.user?.passwordNew,
                cartProductId: Number(i_product.product_id)
            }
        }));
    }

    onUpdateShipping(shipping) {
        this.storeSelector.dispatch(actionLoadCartContentRequest({
            cartRequest: {
                serverCall: "UPDATE_CART_SHIPPING",
                cartCreate: this.cartCreate,
                user: this?.user?.username,
                password: this?.user?.passwordNew,
                shipping
            }
        }));
    }

    onAddCart(i_productId, i_productPrice) {
        this.addedProduct = i_productId.split(':')[0];
        this.storeSelector.dispatch(actionLoadCartContentRequest({
            cartRequest: {
                serverCall: "ADD_CART_CONTENT",
                cartCreate: this.cartCreate,
                user: this?.user?.username,
                password: this?.user?.passwordNew,
                cartProductId: Number(this.addedProduct),
                qty: 1,
                price: i_productPrice
            }
        }));
    }

    calcTotals() {
        const {
            shippingTotal,
            subTotal,
            taxTotal,
            orderTotal
        } = calcTotals(this.dataSource.data, this.selectedShipBy, this.selectedShipTo, this.chargeMode);
        this.shippingTotal = Number(shippingTotal);
        this.subTotal = Number(subTotal);
        this.taxTotal = Number(taxTotal);
        this.orderTotal = Number(orderTotal);
        const t = this.stringJS.transform(String(this.orderTotal), {toCurrency: ['us']});
        let shipping = null;
        if (this.selectedShipTo && this.selectedShipBy) {
            shipping = `${this.selectedShipTo}:${this.selectedShipBy}`;
            this.onUpdateShipping(shipping);
        }
        this.storeSelector.dispatch(actionCartContentUpdate({
                payload: {
                    delivery: +this.shippingTotal.toFixed(2),
                    tax: +this.taxTotal.toFixed(2),
                    total: +this.orderTotal.toFixed(2),
                    subTotal: +this.subTotal.toFixed(2),
                    cartLocation: String(shipping),
                }
            })
        );
    }
}


// declare let RC4V2: any;
// const rc4v2 = new RC4V2();
// const rcData: any = rc4v2.encrypt('foo bar 123', '8547963624824263');
// console.log(rcData);

// if (productId.length > 50) {
//     /** load encrypted order id to cart for charge link **/
//     // this.localStoreService.// swap the order
//
// } else if (compareIds(productId, MS_15)) {
//     /** add custom ms-15 product single item to cart, currently not used, maybe in the future  **/
//     // const productPrice = v.split(':')[1];
//     // setTimeout(() => this.onAddCart(productId, productPrice), 1000);
// } else {
//     /** add regular product to cart **/
//     this.onAddCart(productId, 0);
// }
